import { Routes } from '@angular/router';
import { EditVarieteComponent } from './edit-variete/edit-variete.component';
import { ListeVarietesComponent } from './liste-varietes/liste-varietes.component';

export const VARIETES_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const VARIETES_ROUTES: Routes = [
    { path: '', component: ListeVarietesComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditVarieteComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditVarieteComponent, data: { roles: ['ORGANISME'] } }
];
